

<div class="ramadan-container">
    <div class="container">
<!--      games section-->
      <img src="assets/img/ramadan2022/games-logo.png" class="main-image img-responsive " alt="">
      <div class="games-container">
        <div class="game-container" *ngFor="let game of this.eventService.Games" routerLink="../tournaments" [queryParams]="{game:game.code}">
          <div  class="game-overlay"></div>
          <img   src="assets/img/ramadan2022/{{game.code}}.jpg" alt="">

        </div>
      </div>



      <!--      prizes section-->

      <img src="assets/img/ramadan2022/prizes-logo.png" class="main-image img-responsive " alt="">
            <div class="awards-container">
              <div class="img-container">
                <img class="img-responsive" src="assets/img/ramadan2022/awards-logo.png" >
              </div>
              <div class="prize-container">
                <h3>الجوائز</h3>
                <p>        تصل قيمتها الي<span> $1700</span> </p>
              </div>
          </div>

      <!--      Tournaments section-->
      <img src="assets/img/ramadan2022/tournaments-logo.png" class="main-image img-responsive " alt="">
      <ng-container *ngIf="!eventService.loadEventTournaments; else loading">
        <ng-container *ngIf="tournaments.length !== 0; else nodata">
    <div class="tournament-container">
      <ng-container *ngFor="let tournament of tournaments" >
        <app-tournaments-reusable [tournament]="tournament" [backgroundBody]="'#000000'"
                                  [colorBody]="'#fbc955'" [direction]="'ar'" [fillColor]="'#fbc955'">

        </app-tournaments-reusable>

      </ng-container>

    </div>
          <div class="new_button"  routerLink="../tournaments">
            <div class="border-btn"></div>
            المزيد من البطولات
          </div>
        </ng-container>
      </ng-container>


      <div class="join-us">
        <h3>لمزيد من المعلومات </h3>
        <a style="color: black" href="https://discord.com/channels/291637954290384896/624165637224267776" target="_blank">
        <button>انضم الينا الان <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 27.162 21.026">
          <g data-name="Group 255">
            <g data-name="Group 256">
              <path data-name="Path 10144" d="M23.009 1.761A22.123 22.123 0 0 0 17.409 0a16.431 16.431 0 0 0-.718 1.49 20.576 20.576 0 0 0-6.21 0A15.93 15.93 0 0 0 9.755 0a22.049 22.049 0 0 0-5.613 1.765A23.5 23.5 0 0 0 .115 17.502a22.4 22.4 0 0 0 6.873 3.522 17.092 17.092 0 0 0 1.472-2.425 14.474 14.474 0 0 1-2.318-1.128c.194-.144.385-.295.568-.45a15.838 15.838 0 0 0 13.741 0c.186.155.376.306.568.45a14.438 14.438 0 0 1-2.322 1.13 17.017 17.017 0 0 0 1.472 2.424 22.359 22.359 0 0 0 6.877-3.524 23.479 23.479 0 0 0-4.037-15.74zM9.069 14.335a2.636 2.636 0 0 1-2.442-2.778 2.623 2.623 0 0 1 2.442-2.78 2.606 2.606 0 0 1 2.442 2.78 2.619 2.619 0 0 1-2.442 2.778zm9.024 0a2.636 2.636 0 0 1-2.442-2.778 2.623 2.623 0 0 1 2.442-2.78 2.606 2.606 0 0 1 2.442 2.78 2.621 2.621 0 0 1-2.442 2.778z"/>
            </g>
          </g>
        </svg>
        </button>
        </a>
      </div>

    </div>
<!--  <div class="ramadan-bg-container2">-->
<!--    <div class="container">-->
<!--      <img src="assets/img/ramadan2022/prizes-logo.png" class="main-image img-responsive " alt="">-->
<!--      <div class="games-container">-->

<!--      </div>-->
<!--    </div>-->

<!--  </div>-->

  <ng-template #nodata >
    <div class="no-data " >
      <h2>لم يتم إنشاء بطولات حتى الآن</h2>

    </div>
  </ng-template>

    <ng-template #loading>
      <app-loading-indicator></app-loading-indicator>
    </ng-template>

</div>
